module.exports = __webpack_public_path__ + "static/media/timeup.5bcf196b.mp3";